import { render, staticRenderFns } from "./PcToggle.vue?vue&type=template&id=b25c901e&scoped=true"
import script from "./PcToggle.vue?vue&type=script&lang=js"
export * from "./PcToggle.vue?vue&type=script&lang=js"
import style0 from "./PcToggle.vue?vue&type=style&index=0&id=b25c901e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25c901e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
